import React from "react";

import FormikCalendar from "./FormikCalendar";
import FormikDatePicker from "./FormikDatePicker";
import FormikTextField from "./FormikTextField";
import FormikSelector from "./FormikSelector";

function FormikControl(props) {
  const { control, ...rest } = props;
  switch (control) {
    case "date-picker":
      return <FormikDatePicker {...rest} />;
    case "text-field":
      return <FormikTextField {...rest} />;
    case "calendar":
      return <FormikCalendar {...rest} />;
    case "select":
      return <FormikSelector {...rest} />;

    default:
      return null;
  }
}

export default FormikControl;
